import PropTypes from 'prop-types'; //Themes maintained by ReCAPTCHA

var THEMES = ['light', 'dark'];
export var THEME_PROP_TYPE = PropTypes.oneOf(THEMES);